import { post } from './http';

export const subcribeToBackInStock = async (articleNumber, email) => {
  return post('/api/backinstock', { articleNumber, email });
};
